import SofaIcon from "../../../../assets/svg/sofa.svg?react";

export function Sofa() {
  return <SofaIcon fill="var(--black)" />;
}
